import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { CustomCalloutsContainer } from './';
import CustomCalloutsErrorBoundary from './CustomCalloutsErrorBoundary';
import MarkdownRenderer from '../MarkdownRenderer';
import { publishCounterMetric } from '../../utils/metrics';

import './CustomCalloutsBanner.scss';

const CustomCalloutsBanner = ({ banner, content, locale }) => {
  // maxWidth restricts banner image size so it doesn't take up the whole lab content area
  const { img, alt = '', maxWidth = '1200px' } = banner;

  useEffect(() => {
    publishCounterMetric('CustomCallouts', {
      counterName: 'CustomCallout',
      additionalMetrics: {
        CalloutType: 'banner',
      },
    });
  }, []);

  return (
    <CustomCalloutsErrorBoundary>
      <CustomCalloutsContainer>
        <div className="CustomCallouts__banner">
          <img
            className="CustomCallouts__banner-img"
            src={img}
            alt={alt}
            style={{ maxWidth }}
          />
        </div>
        {content && (
          <MarkdownRenderer
            locale={locale}
            markdown={decodeURIComponent(content)}
            theme="light"
          />
        )}
      </CustomCalloutsContainer>
    </CustomCalloutsErrorBoundary>
  );
};

CustomCalloutsBanner.propTypes = {
  banner: PropTypes.shape({
    img: PropTypes.string.isRequired,
    alt: PropTypes.string,
    maxWidth: PropTypes.string,
  }).isRequired,
  content: PropTypes.string,
  locale: PropTypes.string,
};

export default CustomCalloutsBanner;
